import { render } from "./ProductStocks.vue?vue&type=template&id=18bf1e6b"
import script from "./ProductStocks.vue?vue&type=script&lang=js"
export * from "./ProductStocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__